import React from "react"
export function TaLogo(props) {
  return (
    <svg viewBox="0 0 32 20" {...props}>
      <g
        id="prefix__Page-1"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="prefix__ta-logo"
          transform="translate(.047 .829)"
          fillRule="nonzero"
        >
          <path
            d="M6.497 2.521H0l1.552 2.134c.193.29.678.97.872 1.648a7.965 7.965 0 00-1.163 4.17 8.029 8.029 0 008.048 8.048c1.843 0 3.588-.679 5.043-1.745l1.66 2.424 1.685-2.424c.457.432.932.78 1.535 1.107 1.067.485 2.101.735 3.265.735.97 0 1.842-.194 2.812-.485 4.17-1.551 6.303-6.206 4.752-10.278-.194-.485-.388-.97-.68-1.455.292-.679.777-1.455.874-1.648l1.551-2.134h-6.69C22.593.776 19.393 0 16 0c-3.588 0-6.885.873-9.503 2.521z"
            id="prefix__Combined-Shape"
            fill="#FFF"
          />
          <path
            d="M7.273 4.364c2.52-.291 9.6-.582 7.66 9.697l2.23-.194c-.97-6.303 1.067-9.6 7.37-9.891-10.472-5.721-16.485.29-17.26.388"
            id="prefix__Fill-3"
            fill="#FBC40F"
          />
          <path
            d="M10.376 10.279c0 .582-.485 1.066-1.067 1.066a1.076 1.076 0 01-1.067-1.066c0-.582.485-1.067 1.067-1.067s1.067.485 1.067 1.067"
            id="prefix__Fill-7"
            fill="#EF6945"
          />
          <path
            d="M23.758 10.279c0 .582-.485 1.066-1.067 1.066a1.076 1.076 0 01-1.067-1.066c0-.582.485-1.067 1.067-1.067s1.067.485 1.067 1.067"
            id="prefix__Fill-8"
            fill="#00A680"
          />
          <path
            d="M24.533 15.418c2.812-.97 4.17-4.073 3.2-6.885-1.066-2.812-4.17-4.266-6.885-3.2-1.357.485-2.424 1.552-3.006 2.812-.678 1.261-.678 2.716-.194 4.073.485 1.358 1.552 2.424 2.813 3.006a5.379 5.379 0 004.072.194zM9.31 15.71a5.318 5.318 0 005.333-5.333c0-2.91-2.424-5.334-5.333-5.334-2.909 0-5.333 2.425-5.333 5.334s2.424 5.333 5.333 5.333zM22.497 3.685A17.235 17.235 0 0016 2.425c-2.424 0-4.558.484-6.497 1.26 3.394.097 6.303 2.812 6.497 6.206.097-.776.194-1.552.582-2.327a7.39 7.39 0 013.782-3.491c.678-.194 1.454-.388 2.133-.388zM28.024 6.4c.388.485.679 1.067.97 1.648 1.26 3.491-.485 7.37-3.879 8.63-1.745.68-3.49.583-5.14-.193-.969-.485-1.745-1.164-2.423-1.94l-1.455 2.134-1.455-2.134c-1.26 1.552-3.103 2.522-5.236 2.522-3.685 0-6.69-3.006-6.69-6.691 0-1.455.484-2.91 1.26-3.976-.388-1.26-1.358-2.618-1.358-2.618h4.17C9.309 2.133 12.509 1.26 16 1.26c3.394 0 6.4.872 8.921 2.52h4.46s-.969 1.261-1.357 2.619zM9.212 12.51c1.26 0 2.23-.97 2.133-2.134 0-1.164-.97-2.134-2.133-2.134-1.164 0-2.133.97-2.133 2.134 0 1.163.97 2.133 2.133 2.133zm0-5.528c1.843 0 3.394 1.551 3.297 3.297a3.27 3.27 0 01-3.297 3.297 3.27 3.27 0 01-3.297-3.297 3.27 3.27 0 013.297-3.297zm13.479 5.527c1.164 0 2.133-.97 2.133-2.133 0-1.164-.97-2.134-2.133-2.134-1.164 0-2.133.97-2.133 2.134 0 1.163.97 2.133 2.133 2.133zm0-5.527c1.842 0 3.297 1.551 3.297 3.297a3.27 3.27 0 01-3.297 3.297 3.27 3.27 0 01-3.297-3.297 3.27 3.27 0 013.297-3.297z"
            id="prefix__Combined-Shape"
            fill="#000A12"
          />
        </g>
      </g>
    </svg>
  )
}
